import {
  addColumns,
  createTable,
  schemaMigrations,
} from "@nozbe/watermelondb/Schema/migrations";

// Upgrades the database already on each device instead of wiping it, so
// changes made offline are never lost when the app updates.
export default schemaMigrations({
  migrations: [
    {
      toVersion: 4,
      steps: [
        addColumns({
          table: "products",
          columns: [
            { name: "followup_months", type: "number", isOptional: true },
          ],
        }),
      ],
    },
    {
      toVersion: 3,
      steps: [
        createTable({
          name: "sms_messages",
          columns: [
            { name: "customer_id", type: "string", isIndexed: true },
            { name: "direction", type: "string" },
            { name: "body", type: "string" },
            { name: "to_number", type: "string" },
            { name: "from_number", type: "string" },
            { name: "status", type: "string" },
            { name: "error", type: "string" },
            { name: "created_at", type: "number" },
            { name: "updated_at", type: "number" },
          ],
        }),
      ],
    },
    {
      toVersion: 2,
      steps: [
        addColumns({
          table: "proposals",
          columns: [{ name: "archived_at", type: "number", isOptional: true }],
        }),
      ],
    },
  ],
});
